import React, { useEffect, useCallback } from 'react';

import { createPortal } from 'react-dom';

import { ToastContainer, toast } from 'react-toastify';

import DialogModal from './DialogModal';

import { useUiStore } from '../../store';

export default function GlobalUi() {
  const setNotify = useUiStore((state) => state.setNotify);
  const setNotifyApiError = useUiStore((state) => state.setNotifyApiError);

  const notify = useCallback(({ type, message }) => {
    if (type === 'success') {
      toast.success(message);
    } else if (type === 'error') {
      toast.error(message);
    } else {
      toast(message);
    }
  }, []);

  const notifyApiError = useCallback(
    (error) => {
      notify({
        type: 'error',
        message: error.response?.data?.message || 'Something went wrong',
      });
    },
    [notify]
  );

  useEffect(() => {
    setNotify(notify);
    setNotifyApiError(notifyApiError);
  }, [notify, notifyApiError, setNotify, setNotifyApiError]);

  return (
    <>
      {createPortal(<DialogModal />, document.body)}
      <ToastContainer />
    </>
  );
}
